import { ODSCheckbox } from '@telekom-ods/react-ui-kit';
import PropTypes from 'prop-types';

export const Checkbox = ({
  id,
  name,
  onChange,
  onBlur = () => {},
  label,
  disabled = false,
  checked = false,
  importanceRef = null,
  size = 'small',
}) => (


  <ODSCheckbox
    id={id}
    size={size}
    name={name}
    label={label}
    checked={checked}
    disabled={disabled}
    onChange={onChange}
    onBlur={onBlur}
    ref={importanceRef}
  />
);

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  importanceRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  size: PropTypes.string,
};
